import { render, staticRenderFns } from "./PasswortResetEinstellungen.vue?vue&type=template&id=c13369bc&scoped=true"
import script from "./PasswortResetEinstellungen.vue?vue&type=script&lang=js"
export * from "./PasswortResetEinstellungen.vue?vue&type=script&lang=js"
import style0 from "./PasswortResetEinstellungen.vue?vue&type=style&index=0&id=c13369bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13369bc",
  null
  
)

export default component.exports